export default __webpack_public_path__ + "static/6758-74608f0b2e25d49b26cf07679bbdd564.jpg";